import request from "../utils/request";

export default {
  // 评论列表
  commentList: (query) => {
    return request({
      url: "ms/plat/comment/list",
      method: "post",
      data: query,
    });
  },

  // 修改显示状态
  commentEdit: (query) => {
    return request({
      url: "ms/plat/comment/editStatus",
      method: "post",
      data: query,
    });
  },

  // 获取房东列表
  landLordList: (query) => {
    return request({
      url: "ms/plat/landLord/list",
      method: "get",
      params: query,
    });
  },

  // 设置房东的状态
  landLordSetStatus: (query) => {
    return request({
      url: "ms/plat/landLord/setStatus",
      method: "post",
      data: query,
    });
  },

  // 设置房东的抽佣
  landLordCommission: (query) => {
    return request({
      url: "ms/plat/landLord/commission",
      method: "post",
      data: query,
    });
  },

  // 删除房东
  landLordDel: (query) => {
    return request({
      url: "ms/plat/landLord/del",
      method: "post",
      data: query,
    });
  },

  // 获取名宿业务配置
  platConfig: (query) => {
    return request({
      url: "ms/plat/config",
      method: "get",
      params: query,
    });
  },

  // 保存业务系统配置
  platSaveConfig: (query) => {
    return request({
      url: "ms/plat/saveConfig",
      method: "post",
      data: query,
    });
  },

  // 订单列表
  OrderList: (query) => {
    return request({
      url: "ms/plat/order/list",
      method: "get",
      params: query,
    });
  },

  // 获取结算单列表
  getMsCloseList: (query) => {
    return request({
      url: "ms/plat/settle/getList",
      method: "get",
      params: query,
    });
  },

  // 订单详情
  OrderDetails: (query) => {
    return request({
      url: "ms/plat/order/details",
      method: "get",
      params: query,
    });
  },
  // 生成账单
  addMsClose: (query) => {
    return request({
      url: "ms/plat/bill/createBill",
      method: "post",
      data: query,
    });
  },
  // 获取账单列表
  getMsBillList: (query) => {
    return request({
      url: "ms/plat/bill/getList",
      method: "get",
      params: query,
    });
  },
  // 获取账单详情
  getMsBillDet: (query) => {
    return request({
      url: "ms/plat/bill/getBillDetail",
      method: "get",
      params: query,
    });
  },

  // 打款 / 批量打款
  setMsRemit: (query) => {
    return request({
      url: "ms/plat/bill/remit",
      method: "post",
      data: query,
    });
  },

  // 获取房源列表
  houseList: (query) => {
    return request({
      url: "ms/plat/house/list",
      method: "get",
      params: query,
    });
  },
  // 获取房源详情
  houseDetails: (query) => {
    return request({
      url: "ms/plat/house/details",
      method: "get",
      params: query,
    });
  },
  // 审核房源
  houseExamine: (query) => {
    return request({
      url: "ms/plat/house/examine",
      method: "get",
      params: query,
    });
  },
  // 首页头部数据统计
  getIndexHeadData: (query) => {
    return request({
      url: "ms/plat/home/index",
      method: "get",
      params: query,
    });
  },
  // 订单趋势
  getMsOrderTrend: (query) => {
    return request({
      url: "ms/plat/home/orderTrend",
      method: "get",
      params: query,
    });
  },
  // 入住率趋势
  getMsCheckinTrend: (query) => {
    return request({
      url: "ms/plat/home/checkInTrend",
      method: "get",
      params: query,
    });
  },

  // 获取授权配置
  getMsPlatConfig: (query) => {
    return request({
      url: "ms/plat/open/getConfig",
      method: "get",
      params: query,
    });
  },

  // 保存授权配置
  saveMsPlatConfig: (query) => {
    return request({
      url: "ms/plat/open/saveConfig",
      method: "post",
      data: query,
    });
  },

  // 重置授权配置密钥
  resetMsPlatConfig: (query) => {
    return request({
      url: "ms/plat/open/getSecret",
      method: "get",
      params: query,
    });
  },

  // 获取协议列表
  agreementList: (query) => {
    return request({
      url: "ms/plat/agreement/list",
      method: "get",
      params: query,
    });
  },

  // 获取协议类型
  agreementTypes: (query) => {
    return request({
      url: "ms/plat/agreement/types",
      method: "get",
      params: query,
    });
  },

  // 保存协议
  agreementSaveData: (query) => {
    return request({
      url: "ms/plat/agreement/saveData",
      method: "post",
      data: query,
    });
  },
  // 会员卡列表
  getCardList: (query) => {
    return request({
      url: "ms/plat/card/list",
      method: "get",
      params: query,
    });
  },
  // 获取会员信息
  getCardUserList: (query) => {
    return request({
      url: "ms/plat/cardUser/list",
      method: "get",
      params: query,
    });
  },
  // 获取充值或升级订单
  getTopupList: (query) => {
    return request({
      url: "ms/plat/cardUser/topupList",
      method: "get",
      params: query,
    });
  },
  // 获取充值或升级订单
  getBalanceList: (query) => {
    return request({
      url: "ms/plat/cardUser/balanceList",
      method: "get",
      params: query,
    });
  },
  // 获取充值或升级订单
  getIntegralList: (query) => {
    return request({
      url: "ms/plat/cardUser/integralList",
      method: "get",
      params: query,
    });
  },
  // 获取会员升级结算列表
  cardUserUpgradeList: (query) => {
    return request({
      url: "/ms/plat/cardUser/upgradeList",
      method: "get",
      params: query,
    });
  },
  // 会员升级批量结算
  cardUserUpgradeSettle: (query) => {
    return request({
      url: "/ms/plat/cardUser/upgradeSettle",
      method: "post",
      data: query,
    });
  },
  // 充值结算列表
  statisticsTopupList: (query) => {
    return request({
      url: "/ms/plat/statistics/topupList",
      method: "get",
      params: query,
    });
  },
  // 充值结算
  cardUserTopupSettle: (query) => {
    return request({
      url: "/ms/plat/cardUser/topupSettle",
      method: "post",
      data: query,
    });
  },
};
